import { render, staticRenderFns } from "./ifc-list.vue?vue&type=template&id=28e54dce&scoped=true"
import script from "./ifc-list.vue?vue&type=script&lang=js"
export * from "./ifc-list.vue?vue&type=script&lang=js"
import style0 from "./ifc-list.vue?vue&type=style&index=0&id=28e54dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e54dce",
  null
  
)

export default component.exports